export const paymentOptions = [
  { key: 'rdAll' },
  { key: 'rdOnlyCash' },
  { key: 'rdOnlyPointsAndCashPoints' }
]
export const PAYMENT_OPTION = {
  ALL: paymentOptions[0].key,
  ONLY_CASH: paymentOptions[1].key,
  ONLY_POINTS_AND_CASH_POINTS: paymentOptions[2].key
}
